"use strict"
let Promise = require("bluebird")

/**
 * DO NOT USE IN PRODUCTION
 */

exports.SimpleMemoryStore = function () {
    let values = {}

    this.get = function (key) {
        return Promise.resolve(values[key])
    }

    this.put = function (key, value) {
        values[key] = value

        return Promise.resolve(value)
    }
}
